import { PartialContent } from '@/types/content';

export type EditorState = PartialContent;

export interface Breakpoint {
  width: number;
  height: number;
  zoom: number;
  rotatable: boolean;
}

export const enum DeviceType {
  Phone = 'phone',
  Tablet = 'tablet',
  Laptop = 'laptop',
  Desktop = 'desktop',
}

export const enum Orientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
}

export const enum Zoom {
  Full = 1.0,
  ThreeQuaters = 0.75,
  Half = 0.5,
  Double = 2.0,
  OneAndAHalf = 1.5,
}
